import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { sampleTypesConfigurationServices } from '@/api/resources/configuration/samples/sampleTypes/SampleTypesConfigurationServices'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { ISampleTypeWorkflow } from '@/api/resources/common/sampleTypeWorkflowsService'
import { Nullable } from '@/shared/types/app.types'

export interface IContentSampleTypesGridBase {
    id?: number
    code: string
    description: string
    active: boolean
    workflow: Nullable<ISampleTypeWorkflow | string>
}

export interface ICreatePatchContentSampleTypesGrid extends IContentSampleTypesGridBase{
    workflow: Nullable<string>
}

export interface IContentSampleTypesGrid extends IContentSampleTypesGridBase{
    workflow: Nullable<ISampleTypeWorkflow>
}

export interface ISampleTypesModalState {
    model: IContentSampleTypesGrid
    workflows: Array<ISampleTypeWorkflow>
}
export const initialSampleTypesModalState =
    (): ISampleTypesModalState => ({
        model: {
            id: undefined,
            code: '',
            description: '',
            active: false,
            workflow: null
        },
        workflows: []
    })

export const columnsDefSampleTypesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.externalCode'),
            field: 'code',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            field: 'description',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export type ISampleTypesGridState = CrudModelBase<IContentSampleTypesGrid>
export const initialSampleTypesGridState =
    (): ISampleTypesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.samples.sampleTypes',
        columnsDef: columnsDefSampleTypesGrid(),
        datasource: new PaginatorDatasource(sampleTypesConfigurationServices)
    })
